/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable import/order */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
import styled from 'styled-components';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from 'antd';

import { useConnectSnapStore } from '../hooks';
import { defaultSnapOrigin } from '../config';
import { TEABAG_EXT_ID } from '../env';
import { wait } from '../utils';
import { teal } from '../config/colors';

function Step4AuthSnap() {
  const { snapInstall, snapAuth, setSnapAuthLoading, setSnapAuthCompleted } =
    useConnectSnapStore();
  const [connectionStatus, setConnectionStatus] = useState<any>();

  const checkSnapAuthed = useCallback(async () => {
    setSnapAuthLoading(true);
    await wait(300);
    try {
      const currentConnection: any = await sendGetConnectionStatus();
      if (currentConnection?.connected) {
        setConnectionStatus(currentConnection);
        return setSnapAuthCompleted(true);
      }
      setConnectionStatus(null);
      return setSnapAuthCompleted(false);
    } catch (error) {
      // do nothing
    }
    setSnapAuthLoading(false);
  }, []);

  const authSnap = useCallback(async () => {
    setSnapAuthLoading(true);
    try {
      await transferAuth();
      await checkSnapAuthed();
    } catch (error) {
      console.error(error);
    } finally {
      setSnapAuthLoading(false);
    }
  }, [checkSnapAuthed]);

  const disconnectSnap = useCallback(async () => {
    setSnapAuthLoading(true);
    try {
      await sendDisconnect();
      setConnectionStatus(null);
      setSnapAuthCompleted(false);
    } catch (error) {
      console.error(error);
    } finally {
      setSnapAuthLoading(false);
    }
  }, []);

  const message = useMemo(() => {
    if (!snapInstall.completed) {
      return '';
    }

    if (snapAuth.completed) {
      return (
        <>
          <div className="connectedAs">
            Connected as{' '}
            <span className="email">{connectionStatus?.email}</span>
          </div>
          <Button size="small" onClick={() => authSnap()}>
            Reconnect
          </Button>
          <Button size="small" danger onClick={() => disconnectSnap()}>
            Disconnect
          </Button>
        </>
      );
    }

    return (
      <>
        <div className="description">
          Click the button below.
          <br />
          You will be prompted to grant access
          <br />
          to your account.
        </div>
        <Button size="small" type="primary" onClick={() => authSnap()}>
          Connect
        </Button>
      </>
    );
  }, [
    snapInstall.completed,
    snapAuth.completed,
    connectionStatus,
    authSnap,
    disconnectSnap,
  ]);

  useEffect(() => {
    if (snapInstall.completed) {
      checkSnapAuthed();
    }
  }, [snapInstall.completed]);

  return <Container>{message}</Container>;
}

const Container = styled.div`
  .description {
    margin-bottom: 8px;
  }

  .connectedAs {
    margin-bottom: 8px;
    .email {
      color: ${teal};
    }
  }

  button + button {
    margin-left: 8px;
  }
`;

async function sendGetConnectionStatus() {
  const res = await window.ethereum.request({
    method: 'wallet_invokeSnap',
    params: {
      snapId: defaultSnapOrigin,
      request: { method: 'getConnectionStatus' },
    },
  });

  return res;
}

async function transferAuth() {
  const pending: any = await window.ethereum.request({
    method: 'wallet_invokeSnap',
    params: {
      snapId: defaultSnapOrigin,
      request: { method: 'beginConnect' },
    },
  });
  const authorization: any = await getTeabagAuthorization(
    pending.codeChallenge,
  );
  if (authorization) {
    await window.ethereum.request({
      method: 'wallet_invokeSnap',
      params: {
        snapId: defaultSnapOrigin,
        request: {
          method: 'completeConnect',
          params: {
            state: pending.state,
            grantId: authorization.grantId,
            authorizationCode: authorization.authorizationCode,
          },
        },
      },
    });
  }
}

async function getTeabagAuthorization(codeChallenge: string) {
  return new Promise((resolve, reject) => {
    if (!(window as any).chrome.runtime) {
      return reject(new Error('Chrome runtime not found'));
    }

    (window as any).chrome.runtime.sendMessage(
      TEABAG_EXT_ID,
      {
        __type: 'createSnapAuthorization',
        codeChallenge,
      },
      (response: any) => {
        if ((window as any).chrome.runtime.lastError) {
          return reject((window as any).chrome.runtime.lastError);
        }
        return resolve(response);
      },
    );
  });
}

async function sendDisconnect() {
  return window.ethereum.request({
    method: 'wallet_invokeSnap',
    params: {
      snapId: defaultSnapOrigin,
      request: { method: 'disconnect' },
    },
  });
}

export default Step4AuthSnap;
